import { FC } from "react";
import Typography from "@mui/material/Typography";

interface BreadcrumbItemProps {
  label: string;
  onClick?: () => void;
  id?: string;
}

export const BreadcrumbItem: FC<BreadcrumbItemProps> = (props) => {
  return (
    <Typography
      id={props.id || "breadcrumb-item"}
      fontSize="11px"
      fontWeight={300}
      color="#757575"
      lineHeight={2.91}
      letterSpacing="0.5px"
      sx={{
        cursor: "pointer",
      }}
      onClick={props.onClick}
    >
      {props.label}
    </Typography>
  );
};
